import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import {
  Container,
  Typography,
  Grid,
  Box,
  Card,
  CardContent
} from "@mui/material";

const System = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  const System = [
    {
      title: "MDOS",
      list:
        "ระบบเฝ้าระวังสถานการณ์สารเสพติดบนอินเทอร์เน็ต เฉพาะ เจ้าหน้าที่ ป.ป.ส.",
      link: "https://cmu.to/MDOS2026page"
    },
    {
      title: "SORT",
      list:
        "ระบบเฝ้าระวังภัยความเสี่ยงแบบออนไลน์ในประเทศไทย (บุหรี่ไฟฟ้า เครื่องดื่มแอลกอฮอล์ เกม การพนัน และสารเสพติด)",
      link: "https://cmu.to/SORT2025"
    }
  ];

  return (
    <section
      ref={ref}
      id="system"
      style={{ backgroundColor: "#EEF5FF", padding: "120px 0" }}
    >
      <Container sx={{ textAlign: "center", maxWidth: "md" }}>
        <Typography variant="h5" gutterBottom>
          ระบบเฝ้าระวังออนไลน์
        </Typography>

        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{ display: "flex", flexWrap: "wrap", mt: 5 }}
        >
          {System.map((system, index) =>
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <Card
                  elevation={3}
                  sx={{
                    width: "350px", // กำหนดความกว้างให้เท่ากัน
                    height: "110px", // กำหนดความสูงให้เท่ากัน
                    borderRadius: 4,
                    textAlign: "center",
                    padding: 3,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      transform: "scale(1.05)",
                      transition: "transform 0.3s ease-in-out"
                    },
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    window.open(system.link, "_blank");
                  }}
                >
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      fontWeight: "bold",
                      fontFamily: "Poppins, sans-serif",
                      fontSize: { xs: "1.3rem", sm: "1.6rem", md: "1.8rem" },
                      background:
                        "linear-gradient(90deg,rgb(0, 0, 0),rgb(41, 144, 253))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textShadow: "1px 1px 2px rgba(0,0,0,0.1)"
                    }}
                  >
                    {system.title}
                  </Typography>

                  <CardContent>
                    <Typography
                      variant="h7"
                      gutterBottom
                      sx={{
                        fontSize: "0.8rem"
                      }}
                    >
                      {system.list}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          )}
        </Grid>
      </Container>
    </section>
  );
};

export default System;
